const goToPage = () => {
  const links = document.querySelectorAll('[data-go-to-page]');

  if (!links) return;

  links.forEach((link) => {
    const toPage = link.dataset.goToPage;
    link.addEventListener('click', () => {
      window.location.href = `${window.location.origin}${toPage}`;
    });
  });
};

export default goToPage;
